import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\Admin\Customers\CustomerController::store
* @see app/Http/Controllers/Admin/Customers/CustomerController.php:350
* @route '/customers/{customer}/motel-ratings'
*/
export const store = (args: { customer: string | { id: string } } | [customer: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(args, options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/customers/{customer}/motel-ratings',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\Customers\CustomerController::store
* @see app/Http/Controllers/Admin/Customers/CustomerController.php:350
* @route '/customers/{customer}/motel-ratings'
*/
store.url = (args: { customer: string | { id: string } } | [customer: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { customer: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { customer: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            customer: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        customer: typeof args.customer === 'object'
        ? args.customer.id
        : args.customer,
    }

    return store.definition.url
            .replace('{customer}', parsedArgs.customer.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Customers\CustomerController::store
* @see app/Http/Controllers/Admin/Customers/CustomerController.php:350
* @route '/customers/{customer}/motel-ratings'
*/
store.post = (args: { customer: string | { id: string } } | [customer: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Customers\CustomerController::store
* @see app/Http/Controllers/Admin/Customers/CustomerController.php:350
* @route '/customers/{customer}/motel-ratings'
*/
const storeForm = (args: { customer: string | { id: string } } | [customer: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Customers\CustomerController::store
* @see app/Http/Controllers/Admin/Customers/CustomerController.php:350
* @route '/customers/{customer}/motel-ratings'
*/
storeForm.post = (args: { customer: string | { id: string } } | [customer: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(args, options),
    method: 'post',
})

store.form = storeForm

const motelRatings = {
    store: Object.assign(store, store),
}

export default motelRatings